import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <div>
        <div className="page-title-section section">
          <div className="page-title">
            <div className="container">
              <h1 className="title">Məxfilik Siyasəti</h1>
            </div>
          </div>
        </div>
        {/* Page Title Section End */}
        {/* Privacy Policy Section Start */}
        <div className="section section-padding-bottom">
          <div className="container">
            <div className="row max-mb-n50">
              <div className="col-lg-12 col-12 order-lg-2 max-mb-50">
                {/* Privacy Policy Wrapper Start */}
                <div className="privacy-policy-wrapper">
                  <div className="content">
                    <p>
                      Turan Özbahçeci saytına xoş gəlmisiniz. Biz sizin
                      gizliliyinizi çox önəmli hesab edirik və şəxsi
                      məlumatlarınızın qorunması üçün ciddi tədbirlər görürük.
                      Bu gizlilik siyasəti, saytımızı istifadə edərkən
                      topladığımız məlumatların necə istifadə olunduğunu və
                      qorunduğunu açıqlayır.
                    </p>
                    <h3 className="title">Topladığımız Məlumatlar</h3>
                    <p>
                      Saytımızı istifadə edərkən, sizin tərəfinizdən müxtəlif
                      məlumatlar toplaya bilərik. Bu məlumatlar aşağıdakılardan
                      ibarət ola bilər:
                    </p>
                    <ul>
                      <li>
                        Şəxsi Məlumatlar: Ad, soyad, e-poçt ünvanı, telefon
                        nömrəsi və digər əlaqə məlumatları.
                      </li>
                      <li>
                        Texniki Məlumatlar: IP ünvanı, brauzer növü, istifadə
                        etdiyiniz cihazın növü, saytımızı ziyarət etmə tarixləri
                        və saatları.
                      </li>
                      <li>
                        Çerezlər (Cookies): Saytımızın təcrübəsini
                        yaxşılaşdırmaq üçün çerezlərdən istifadə edirik.
                        Çerezlər, kompüterinizdə və ya mobil cihazınızda
                        saxlanan kiçik fayllardır.
                      </li>
                    </ul>
                    <h3 className="title">Məlumatların İstifadəsi</h3>
                    <p>
                      Topladığımız məlumatlar aşağıdakı məqsədlər üçün istifadə
                      edilə bilər:
                    </p>
                    <ul>
                      <li>
                        Saytımızın funksiyalarını təmin etmək və inkişaf
                        etdirmək.
                      </li>
                      <li>
                        Sizinlə əlaqə qurmaq, suallarınıza cavab vermək və
                        xidmətlərimiz haqqında sizi məlumatlandırmaq.
                      </li>
                      <li>
                        Saytın trafikini izləmək və istifadəçi təcrübəsini
                        yaxşılaşdırmaq.
                      </li>
                      <li>Qanuni öhdəliklərimizi yerinə yetirmək.</li>
                    </ul>
                    <h3 className="title">Məlumatların Paylaşılması</h3>
                    <p>
                      Biz, topladığımız şəxsi məlumatları üçüncü tərəflə
                      paylaşmırıq, yalnız aşağıdakı hallar istisna olmaqla:
                    </p>
                    <ul>
                      <li>
                        Hüquqi öhdəliklərimizi yerinə yetirmək (məsələn, məhkəmə
                        qərarlarına əsasən).
                      </li>
                      <li>
                        Bizim adımıza xidmət göstərən üçüncü tərəf şirkətlər
                        (məsələn, hosting xidmətləri və analiz vasitələri) ilə
                        məlumatları paylaşa bilərik. Bu şirkətlər yalnız bu
                        məqsədlə məlumatları istifadə edəcəklər.
                      </li>
                    </ul>
                    <h3 className="title">Məlumatların Təhlükəsizliyi</h3>
                    <p>
                      Biz şəxsi məlumatlarınızın təhlükəsizliyini təmin etmək
                      üçün müvafiq texniki və təşkilati tədbirlər görürük.
                      Lakin, internet üzərindən məlumatların ötürülməsi tamamilə
                      təhlükəsiz olmaya bilər və biz məlumatların ötürülməsində
                      100% təhlükəsizlik təminatını verə bilmərik.
                    </p>
                    <h3 className="title">Çerezlər (Cookies)</h3>
                    <p>
                      Saytımızı ziyarət edərkən çerezlərdən istifadə edirik.
                      Çerezlər, saytımızı istifadə etməniz əsnasında əldə edilən
                      məlumatları yadda saxlayır və bu məlumatlar istifadəçi
                      təcrübəsini yaxşılaşdırmaq üçün istifadə olunur. Çerezlər
                      haqqında daha ətraflı məlumatı və necə idarə edə
                      biləcəyinizi brauzer parametrlərinizdən əldə edə
                      bilərsiniz.
                    </p>
                    <h3 className="title">Uşaqların Məlumatları</h3>
                    <p>
                      Saytımızda 18 yaşından kiçik şəxslərdən məlumat toplanması
                      məqsədilə xidmət göstərilmir. 18 yaşından kiçik şəxslərdən
                      məlumat topladığımızı düşünürsəniz, bizimlə əlaqə saxlayın
                      və məlumatları siləcəyik.
                    </p>
                    <h3 className="title">
                      Gizlilik Siyasətində Dəyişikliklər
                    </h3>
                    <p>
                      Gizlilik siyasətimizi zaman-zaman yeniləyə bilərik. Hər
                      hansı bir dəyişiklik etdikdə, saytımızda bu dəyişiklikləri
                      qeyd edəcəyik. Bu səhifəni mütəmadi olaraq yoxlayaraq
                      siyasətimizdəki yeniliklərdən xəbərdar ola bilərsiniz.
                    </p>
                    <h3 className="title">
                    Əlaqə
                    </h3>
                    <p>
                    Əgər bu gizlilik siyasəti ilə bağlı hər hansı bir sualınız varsa, bizə aşağıdakı əlaqə məlumatları ilə müraciət edə bilərsiniz:
                    </p>
                    <a href="mailto:t.ozbahceci@ozbahceci.org">E-poçt: t.ozbahceci@ozbahceci.org</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
